import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { DataMaterialsService } from '@components/materials/data-materials.service';
var OrdersMaterialsComponent = /** @class */ (function () {
    function OrdersMaterialsComponent(dataMaterialsService, router) {
        this.dataMaterialsService = dataMaterialsService;
        this.router = router;
        this.projectRooms = [];
        // loading
        this.isLoaded = false;
        // NUmber Materials
        this.stateMaterials = {
            total: 0,
            inDelivery: 0,
            delivered: 0
        };
        this.getScreenSize();
    }
    OrdersMaterialsComponent.prototype.getScreenSize = function () {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    };
    OrdersMaterialsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var projectRooms, projectMaterials, wrapperSidebar;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoaded = false;
                        projectRooms = _.cloneDeep(this.dataMaterialsService.projectRooms);
                        return [4 /*yield*/, this.dataMaterialsService.computeProjectMaterialsData()];
                    case 1:
                        _a.sent();
                        projectMaterials = this.dataMaterialsService.getProjectMaterials();
                        this.stateMaterials = OrdersMaterialsComponent.checkStateMats(projectMaterials.items);
                        this.projectRooms = this.formatProjectRoomsWithMat(projectRooms, projectMaterials.items);
                        if (this.screenWidth < 767) {
                            wrapperSidebar = document.getElementById('sidebar');
                            wrapperSidebar.style.display = 'none';
                        }
                        this.isLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    OrdersMaterialsComponent.prototype.formatProjectRoomsWithMat = function (projectRooms, projectMaterials) {
        var _this = this;
        var pr = projectRooms.map(function (r) {
            var projectRoom = tslib_1.__assign({}, r);
            projectRoom.project_materials = projectRoom.materials.map(function (mat) {
                if (['validation_lw', 'validation_by_signature'].includes(mat.status)) {
                    return projectMaterials.find(function (m) { return m.id_material_version === mat.version.id; });
                }
                return null;
            }).filter(function (i) { return i; });
            return projectRoom;
        }).filter(function (r) { return r.project_materials.length > 0; });
        return pr.map(function (r) {
            r.project_materials.map(function (pm) {
                pm.mainImg = (pm._related.material_version_images.length > 0
                    && pm._related.material_version_images[0] !== null
                    && pm._related.material_version_images[0].id_image !== null)
                    ? _this.dataMaterialsService
                        .getSafeStyleImgURL(pm._related.material_version_images[0].id_image, 'small')
                    : '/assets/images/placeholder-img.png';
                return pm;
            });
            return r;
        });
    };
    OrdersMaterialsComponent.prototype.calcMatDelivered = function (materials) {
        return materials.filter(function (mat) { return mat.state === 'delivered'; }).length;
    };
    OrdersMaterialsComponent.checkStateMats = function (projMat) { return ({
        total: projMat.length,
        inDelivery: projMat.filter(function (mat) { return mat.state === 'CMD'; }).length,
        delivered: projMat.filter(function (mat) { return mat.state === 'delivered'; }).length
    }); };
    return OrdersMaterialsComponent;
}());
export { OrdersMaterialsComponent };
